export enum Role {
    ROLE_SUPER_ADMIN,
    ROLE_ADMIN,
    ROLE_CONSTRUCTEUR,
    ROLE_PROMOTEUR,
    ROLE_BAILLEUR,
    ROLE_PARTICULIER,
    ROLE_LOCATAIRE,
    ROLE_PROPRIETAIRE,
    ROLE_COLLABORATEUR
}
